import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReservationCalendarComponent } from './reservation-calendar.component';
import { CalendarModule } from 'angular-calendar';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { LetDirectiveModule } from '@web/app/directives/let/let.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { TranslateDomainModule } from "@web/app/pipes/translate/translate-domain.module";
import { ReservationCalendarEventComponent } from "./event-template/reservation-calendar-event/reservation-calendar-event.component"
import { MatBadgeModule } from '@angular/material/badge';
import { WsTooltipModule } from '@web/util/ws-ui/ws-tooltip/ws-tooltip.module';
import { WsUiModule } from '@web/util/ws-ui/ws-ui.module';

@NgModule({
  declarations: [ReservationCalendarComponent, ReservationCalendarEventComponent],
  exports: [
    ReservationCalendarComponent,
    ReservationCalendarEventComponent
  ],
  imports: [
    CommonModule,
    CalendarModule,
    MatIconModule,
    TranslateModule,
    LetDirectiveModule,
    FlexLayoutModule,
    MatButtonModule,
    TranslateDomainModule,
    MatBadgeModule,
    WsTooltipModule,
    WsUiModule
  ]
})
export class ReservationCalendarModule { }
